import Button from '@ui/button/Button';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import whatInput from 'what-input';
import customEventBus from '@common/scripts/libs/eventBus';
import api from '@common/utils/api';
import GiftCardPurchaseModal from '../product/GiftCardPurchaseModal';
import classNames from 'classnames';
import { addURLParameter } from '@common/utils/urlutils';
const WishlistMoveToCart = (props) => {
    var _a, _b, _c, _d;
    let { t } = useTranslation();
    const [giftCardPurchase, setGiftCardPurchase] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(props.loading || false);
    useEffect(() => {
        setButtonLoader(!!props.loading);
    }, [props.loading]);
    const addToBag = (fromKeyboard = false, card) => {
        props.onAddStart && props.onAddStart();
        if (!props.size) {
            console.log('no size, triggering size selector:', props.triggerOpenSize);
            setShowSizeBtn(true);
            props.triggerOpenSize && props.triggerOpenSize();
            return;
        }
        const productId = `${props.product.id}${props.size.id}`;
        // add button loader
        setButtonLoader(true);
        api.moveFromWishlistToCart(props.product.listitemid, props.type, card).then((data) => {
            if (data.error) {
                props.updateErrorMessage && props.updateErrorMessage(data.message);
            }
            else {
                if (data.quantityTotal) {
                    const header = document.querySelector('header');
                    const firstRefine = document.querySelector('.listing-container .refine');
                    header.style.removeProperty('transform');
                    if (firstRefine) {
                        firstRefine.style.removeProperty('transform');
                    }
                    customEventBus.emit('bag:update', { fromMinicart: true });
                    customEventBus.emit('minicart:update', { fromAddToBag: props.wishlist.items.length > 1, fromKeyboard, pid: productId });
                }
                if (props.pushAnalytics) {
                    props.pushAnalytics();
                }
                // sposto qui la callback, in modo che viene eseguita come ultima operazione se la chiamata va a buon fine
                if (props.callback) {
                    props.callback();
                }
            }
            // remove button loader
            setButtonLoader(false);
        });
    };
    const addToBagHandler = () => {
        var _a;
        if (!buttonLoader) {
            ((_a = props === null || props === void 0 ? void 0 : props.product) === null || _a === void 0 ? void 0 : _a.isGiftCard) && !props.product.giftCardAttributes ? setGiftCardPurchase(true) : addToBag(whatInput.ask() === 'keyboard', giftCardCart);
        }
    };
    const redirectToLogin = () => {
        window.location.href = addURLParameter(window.loginUrl, 'redirectToPdp', props.product.id);
    };
    let btnClass = props.secondary ? 'button--secondary' : 'button--primary';
    if (props.inverted) {
        btnClass += '-inverted';
    }
    const classes = [btnClass];
    const [showSizeBtn, setShowSizeBtn] = useState(false);
    const [giftCardProduct, setGiftCardProduct] = useState();
    //setup AddToCart giftCard
    const giftCardCart = props.product.isGiftCard && props.product.giftCardAttributes ? {
        gcAmount: props.product.price.sales.value,
        gcEmail: props.product.giftCardAttributes.recipientEmail,
        gcName: props.product.giftCardAttributes.recipientName,
        gcMessage: props.product.giftCardAttributes.message,
        gcDate: props.product.giftCardAttributes.sendDate
    } : {};
    return !window.loggedin && window.loginUrl && ((_a = props.product) === null || _a === void 0 ? void 0 : _a.unlock) ? (React.createElement(Button, { type: "button", cls: classes, className: props.className, onClick: () => redirectToLogin() }, t('button.signintopurchase'))) : (React.createElement("div", { className: "wishlist__single-product__add-btn", onMouseEnter: () => {
            whatInput.ask() === 'mouse' && !props.size && setShowSizeBtn(true);
        }, onMouseLeave: () => {
            whatInput.ask() === 'mouse' && setShowSizeBtn(false);
        } },
        React.createElement(Button, { type: "button", "aria-disabled": buttonLoader, cls: classes, className: classNames(props.className, { 'button__loader': buttonLoader }), onClick: () => addToBagHandler() }, showSizeBtn
            ? t('label.selectasize')
            : ((_d = (_c = (_b = props.product.variationAttributes) === null || _b === void 0 ? void 0 : _b.find((va) => va.id == 'color')) === null || _c === void 0 ? void 0 : _c.values.find((va) => va.selected)) === null || _d === void 0 ? void 0 : _d.preorderable)
                ? t('button.preordernow')
                : props.product.isGiftCard && !props.product.giftCardAttributes
                    ? t('button.gcConfigure')
                    : t('button.addtobag')),
        React.createElement(GiftCardPurchaseModal, { isOpen: giftCardPurchase, onRequestClose: () => setGiftCardPurchase(false), type: 'edit', 
            //@ts-ignore
            product: props.product, onSubmit: (card, formDef) => props.updateGiftCard(card, formDef), onMoveToBag: card => addToBag(whatInput.ask() === 'keyboard', card) })));
};
export default WishlistMoveToCart;
